"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formatPrice_1 = require("../../helpers/formatPrice");
var checkCreditDiscount_module_scss_1 = __importDefault(require("./checkCreditDiscount.module.scss"));
var CheckMarker_1 = require("../checkMarker/CheckMarker");
var CheckCreditDiscount = function (props) {
    var discountValue = props.discountValue, description = props.description, setDiscount = props.setDiscount;
    var handleCheckChange = function (event) {
        var _a = event.currentTarget, value = _a.value, checked = _a.checked;
        var numericValue = Number(value);
        if (checked) {
            setDiscount(function (prev) { return prev + numericValue; });
        }
        else {
            setDiscount(function (prev) { return prev - numericValue; });
        }
    };
    return (react_1.default.createElement("label", { className: checkCreditDiscount_module_scss_1.default.car_discount__label },
        react_1.default.createElement("input", { onChange: handleCheckChange, defaultChecked: true, value: discountValue, type: "checkbox", name: "credit-calc" }),
        react_1.default.createElement("span", { className: checkCreditDiscount_module_scss_1.default.car_discount__item },
            react_1.default.createElement("span", { className: checkCreditDiscount_module_scss_1.default.car_discount__description },
                react_1.default.createElement("span", null,
                    (0, formatPrice_1.formatPrice)(discountValue),
                    "\u20BD"),
                react_1.default.createElement("span", null, description)),
            react_1.default.createElement("span", { className: checkCreditDiscount_module_scss_1.default.car_discount__check_wrapper },
                react_1.default.createElement(CheckMarker_1.CheckMarker, null)))));
};
exports.default = CheckCreditDiscount;
